<template>
  <div class="create-edit-customer-modal petit-nature-modal">
    <div class="header">
      <h1 class="subtitle is-4" v-if="isCreateCustomer">Novo cliente</h1>
      <h1 class="subtitle is-4" v-else>Editar cliente</h1>
      <span class="close-button" @click="$emit('close')">
        <i class="mdi mdi-window-close"></i>
      </span>
    </div>
    <form
      action=""
      class="body"
      novalidate
      @submit.prevent="validateBeforeSubmit"
    >
      <div class="columns is-multiline is-variable">
        <div class="column is-6">
          <div
            class="field"
            :class="{
              'input-error':
                !$v.customer.name.$required && $v.customer.name.$error
            }"
          >
            <label class="label" for="customerName">Nome (*)</label>
            <div class="control">
              <input
                type="text"
                class="input"
                id="customerName"
                name="customerName"
                v-model.trim="$v.customer.name.$model"
              />
              <b-tooltip
                label="Campo requerido"
                type="is-danger"
                v-if="!$v.customer.name.$required && $v.customer.name.$error"
              >
                <span class="error-icon has-text-danger"
                  ><i class="mdi mdi-alert-circle"></i
                ></span>
              </b-tooltip>
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label" for="customerCPF">CPF</label>
            <input
              type="tel"
              id="customerCPF"
              class="input"
              name="customerCPF"
              v-mask="'###.###.###-##'"
              v-model.trim="customer.cpf"
            />
          </div>
        </div>
        <div class="column is-6">
          <div  class="field"
                :class="{
              'input-error':
                !$v.customer.email.$required && $v.customer.email.$error
            }">
            <label class="label" for="customerEmail">Email (*)</label>
            <div class="control">
              <input
                type="email"
                class="input"
                id="customerEmail"
                name="customerEmail"
                v-model.trim="$v.customer.email.$model"
              />
              <b-tooltip
                  label="Insira um e-mail válido"
                  type="is-danger"
                  v-if="!$v.customer.email.$required && $v.customer.email.$error"
              >
                <span class="error-icon has-text-danger"
                ><i class="mdi mdi-alert-circle"></i
                ></span>
              </b-tooltip>
            </div>
          </div>
        </div>

        <div class="column is-4">
          <div class="field">
            <label class="label" for="customercep">CEP</label>
            <div class="control">
              <input
                type="tel"
                id="customercep"
                name="customercep"
                v-mask="['#####-###']"
                class="input"
                v-model.trim="customer.address.cep"
              />
            </div>
          </div>
        </div>
        <div class="column is-8">
          <div class="field">
            <label class="label" for="customerAddress">Endereço</label>
            <div class="control">
              <input
                type="text"
                id="customerAddress"
                name="customerAddress"
                v-model.trim="customer.address.street"
                class="input"
              />
            </div>
          </div>
        </div>
        <div class="column is-8">
          <div class="field">
            <label class="label" for="customerComplement">Complemento</label>
            <div class="control">
              <input
                type="text"
                id="customerComplement"
                name="customerComplement"
                v-model.trim="customer.address.complement"
                class="input"
              />
            </div>
          </div>
        </div>

        <div class="column is-4">
          <div class="field">
            <label class="label" for="customerNumber">Número</label>
            <div class="control">
              <input
                type="text"
                id="customerNumber"
                name="customerNumber"
                v-model.trim="customer.address.number"
                class="input"
              />
            </div>
          </div>
        </div>

        <div class="column is-4">
          <div class="field">
            <label class="label" for="customerNeighborhood">Bairro</label>
            <div class="control">
              <input
                type="text"
                id="customerNeighborhood"
                name="customerNeighborhood"
                class="input"
                v-model.trim="customer.address.neighborhood"
              />
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label" for="customerCity">Cidade</label>
            <div class="control">
              <input
                type="text"
                id="customerCity"
                name="customerCity"
                v-model.trim="customer.address.city"
                class="input"
              />
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field"
               :class="{
              'input-error':
                !$v.customer.address.uf.$required && $v.customer.address.uf.$error
            }">
            <label class="label" for="customerState">Estado (UF) *</label>
            <div class="control">
              <input
                type="text"
                id="customerState"
                name="customerState"
                v-mask="['AA']"
                class="input"
                v-model.trim="$v.customer.address.uf.$model"
              />
              <b-tooltip
                  label="Campo requerido"
                  type="is-danger"
                  v-if="!$v.customer.address.uf.$required && $v.customer.address.uf.$error"
              >
                <span class="error-icon has-text-danger"
                ><i class="mdi mdi-alert-circle"></i
                ></span>
              </b-tooltip>
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label" for="customerName">Dia de cobrança</label>
            <div class="control">
              <input
                type="number"
                class="input"
                minlength="1"
                maxlength="31"
                id="payday"
                name="payday"
                v-model.trim="customer.payday"
              />
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label" for="customerPhone">Telefone</label>
            <div class="control">
              <input
                type="text"
                id="customerPhone"
                name="customerPhone"
                v-mask="['(##) #####-####', '(##) ####-####']"
                class="input"
                v-model.trim="customer.phone"
              />
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field" style="margin-top: 39px">
            <b-checkbox v-model="customer.active"
            >Cliente ativo?</b-checkbox
            >
          </div>
        </div>
      </div>

      <div class="columns is-multiline is-variable">
        <div class="column is-12 has-text-right">
          <button
            type="submit"
            class="button is-medium is-primary"
            :class="{ 'is-loading': isPendingAction }"
            :disabled="
              isPendingAction || $v.customer.$invalid
            "
          >
            <span v-if="isCreateCustomer">Adicionar</span>
            <span v-else>Salvar</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import { mapState, mapActions } from "vuex";
import NotificationsWrapper from "../../helpers/NotificationsWrapper";

export default {
  name: "CreateEditCustomerModal",
  data: () => ({
    isCreateCustomer: true,
    isPendingAction: false,
    customer: { pets: [] },
    activeTab: 0
  }),
  computed: {
    ...mapState({})
  },
  methods: {
    ...mapActions({
      createCustomer: "customer/createCustomer",
      editCustomer: "customer/editCustomer"
    }),
    validateBeforeSubmit() {
      if (this.customer.$invalid) {
        return;
      }
      this.isPendingAction = true;
      if (this.isCreateCustomer) {
        this.createCustomer(this.customer)
          .then(() => {
            this.isPendingAction = false
            NotificationsWrapper.success("Cliente cadastrado com sucesso!");
            this.$emit("close");
          })
          .catch(error => {
            let errorCode = { error }.error.response.status;

            this.isPendingAction = false;

            const emailAlreadyInUse = "Email already in use.";
            let message =
              "Não foi possível cadastrar o cliente. Tente novamente.";
            switch (errorCode) {
              case 409:
                if(emailAlreadyInUse === { error }.error.response.data.errors) {
                  message = "O email já está em uso";
                }
                break;
            }
            NotificationsWrapper.error(
              message
            );
          })
          .finally(() => (this.isPendingAction = false));
      } else {
        this.editCustomer(this.customer)
          .then(() => {
            this.isPendingAction = false
            NotificationsWrapper.success("Cliente atualizado com sucesso!");
            this.$emit("close");
          })
          .catch(error => {
            this.isPendingAction = false
            let errorCode = { error }.error.response.status;
            switch (errorCode) {
              default:
                NotificationsWrapper.error(
                  "Não foi possível atualizar o cliente. Tente novamente."
                );
                break;
            }
          })
          .finally(() => (this.isPendingAction = false));
      }
    }
  },
  validations: {
    customer: {
      name: { required },
      email: { required, email},
      address:{uf: {required}}
    }
  },
  props: {
    customerParam: {}
  },
  created() {
    if (!this.customerParam.id) {
      this.isCreateCustomer = true;
      this.customer = {
        name: "",
        address: {
          cep: "",
          number: "",
          neighborhood: "",
          uf: "",
          city: "",
          street: "",
          complement: ""
        },
        pets: [],
        email: "",
        payday: "",
        active: true
      };
    } else {
      this.customer = this.customerParam;
      this.isCreateCustomer = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.min-tab-size {
  height: 450px;
  max-height: 450px;
  overflow: auto;
}
</style>
